'use client'

import { Box, Text, Flex, Button, Image } from '@chakra-ui/react'
import { BottomNav } from '@/components/ui/bottom-nav'
import HomeVideos from '@/components/home/home-videos'
import Link from 'next/link'

export default function WatchlistGuestView() {
  return (
    <>
      <Box pb={10} px={[4, 4, 4, 4]}>
        <Flex
          justifyContent={'center'}
          alignItems={'center'}
          flexDir={'column'}
          pt={100}
          pb={20}
        >
          <Image mb={3} src="/guest/watchlist.svg" alt="Rewards" boxSize={75} />
          <Text fontSize={[24]} fontWeight={600} textAlign={'center'}>
            Sign in to create watchlist
          </Text>

          <Flex gap={5} mt={5}>
            <Button
              width={200}
              size={'md'}
              bg={'lyk-red'}
              color={'white'}
              as={Link}
              href="/auth/login"
            >
              Sign In
            </Button>
          </Flex>
        </Flex>

        <Box mb={10}>
          <Text
            textAlign={['center', 'center', 'left']}
            mb={5}
            fontSize={24}
            fontWeight={500}
          >
            You might enjoy
          </Text>

          <HomeVideos />
        </Box>

        <BottomNav />
      </Box>
    </>
  )
}
